import React from "react";
import "../styles/loadingBar.css";

export default function LoadingBar() {
  // New loading bar
  return <div className="loading-bar" />;
}
